import {Component, OnInit} from '@angular/core';
import {AppConfigService} from "../../services/config/app-config.service";
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public addressLine1: string | undefined;
  public addressLine2: string | undefined;
  public website: string | undefined;
  public phone: string | undefined;
  public email: string | undefined;
  public disclaimer: string | undefined;
  userType: string | null = "";
  env: string | null | undefined;

  constructor(private appConfig: AppConfigService, private tokenStorageService: TokenStorageService) {
    this.addressLine1 = appConfig.getAsiaConfig?.contactDetails.addressLine1;
    this.addressLine2 = appConfig.getAsiaConfig?.contactDetails.addressLine2;
    this.website = appConfig.getAsiaConfig?.contactDetails.website;
    this.phone = appConfig.getAsiaConfig?.contactDetails.phone;
    this.email = appConfig.getAsiaConfig?.contactDetails.email;
    this.disclaimer = appConfig.getAsiaConfig?.disclaimer;

    this.userType = tokenStorageService.getUserType();
    console.log("userType", this.userType);


  }

  ngOnInit(): void {
  }

}
